import { render, staticRenderFns } from "./LocationVendorSetting.vue?vue&type=template&id=f89398c4"
import script from "./LocationVendorSetting.vue?vue&type=script&lang=js"
export * from "./LocationVendorSetting.vue?vue&type=script&lang=js"
import style0 from "./LocationVendorSetting.vue?vue&type=style&index=0&id=f89398c4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports